import React from 'react';

export const BodyLipsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.709 57.063C10.709 57.063 18.8652 47.438 49.7715 45.5943C80.6777 43.7505 89.2715 57.2193 89.2715 57.2193C89.2715 57.2193 74.6152 67.5943 49.8965 68.3756C49.8965 68.3756 34.4277 70.6567 10.709 57.063Z"
        fill="#533566"
      />
      <path
        d="M49.9902 54.75C66.11 54.75 79.1777 51.756 79.1777 48.0625C79.1777 44.3691 66.11 41.375 49.9902 41.375C33.8704 41.375 20.8027 44.3691 20.8027 48.0625C20.8027 51.756 33.8704 54.75 49.9902 54.75Z"
        fill="#F4F4F4"
      />
      <path
        d="M82.4902 37.0625L93.3965 54.2187C93.9974 55.1769 93.8049 56.2448 93.1875 56.9487L92.6464 58.031C85.5526 72.4685 68.2089 86.906 52.1151 86.906H47.8964C31.8026 86.906 14.4589 72.4372 7.27138 58.031L6.64638 56.781C6.61659 56.7214 6.5926 56.6614 6.57404 56.6014C6.16724 55.9161 6.10315 55.0214 6.61523 54.2187L17.3965 37.2812C18.1465 35.7187 20.5527 32.4687 20.5527 32.4687C24.5215 27.9062 30.334 25 36.8652 25C41.8027 25 46.3652 26.6562 49.9902 29.4374C53.6465 26.6562 58.1777 25 63.1152 25C69.6152 25 75.459 27.9062 79.4277 32.4687C79.4277 32.4687 81.8027 35.6562 82.4902 37.0625ZM12.3399 56.5529L18.8339 58.531C39.1151 64.6872 60.7714 64.6872 81.0839 58.531L87.5944 56.5479L72.8965 51.5625C58.0527 46.5313 41.9277 46.5313 27.0527 51.5625L12.3399 56.5529Z"
        fill="#F92F60"
      />
    </svg>
  );
};
